// Transfer Getters

export const getTransferList = state => {
  return state.transferList
}

export const getTransferProductsList = state => {
  return state.transferProductsList
}

export const getTransferInfo = state => {
  return state.transferInfo
}

export const getPendingTransferCount = state => {
  return state.pendingTransferCount
}

export const getTransferOutletsList = state => {
  return state.transferOutletsList
}
